var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const Svg1M = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.652 6.036c.204 0 .402-.017.595-.051.193-.034.366-.09.519-.17.158-.08.291-.181.4-.306a.918.918 0 0 0 .22-.459h.79V11H4.115V6.801H2.652v-.765zM6.874 4.931H8.37l1.674 4.752h.017l1.632-4.752h1.48V11H12.16V6.317h-.017L10.46 11h-.876L7.902 6.317h-.017V11H6.874V4.931z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(Svg1M);
export default ForwardRef;